<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? '新增' : '删除'" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
            <el-form-item prop="name" label="政策名称">
                <el-input v-model="dataForm.name" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="type" label="政策类型">
                <el-select v-model="dataForm.type" placeholder="请选择政策类型">
                    <el-option v-for="item in typeList" :key="item.id" :label="item.label" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="政策内容：" prop="content">
                <wangEditor v-model="dataForm.content"></wangEditor>
            </el-form-item>
            <el-form-item label="所需材料：" prop="cailiao">
                <wangEditor v-model="dataForm.cailiao"></wangEditor>
            </el-form-item>
            <el-form-item label="办理方式：" prop="way">
                <wangEditor v-model="dataForm.way"></wangEditor>
            </el-form-item>
            <el-form-item label="咨询电话：" prop="mobile">
                <wangEditor v-model="dataForm.mobile"></wangEditor>
            </el-form-item>

        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">确定</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'
    import uploadImage from "../../../components/uploadImage";
    import wangEditor from "@/components/wangEditor";
    export default {
        components: { uploadImage, wangEditor },
        data () {
            return {
                visible: false,
                dataForm: {
                    id: null,
                    "name": "",
                    "type": "",
                    "content": "",
                    "cailiao": "",
                    "way": "",
                    "mobile": "",
                },
                typeList: [
                    {id: 1, label: '残疾人证'},
                    {id: 2, label: '健康救助'},
                ]
            }
        },
        computed: {
            dataRule () {
                return {
                    name: [
                        { required: true, message: '请输入', trigger: 'blur' }
                    ],
                    type: [
                        { required: true, message: '请选择', trigger: 'blur' }
                    ],
                    content: [
                        { required: true, message: '请输入', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            init () {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    if (this.dataForm.id) {
                        this.getInfo()
                    }
                })
            },
            // 获取信息
            getInfo () {
                this.$http.get(`/position/policy/${this.dataForm.id}`).then(({ data: res }) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = res.policy
                }).catch(() => {})
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http.post(
                        this.dataForm.id ? '/position/policyUpdate' : '/position/policySave',
                        this.dataForm,
                    ).then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {})
                })
            }, 1000, { 'leading': true, 'trailing': false })
        }
    }
</script>
